import { render, staticRenderFns } from "./studentActivity.vue?vue&type=template&id=1a629c14&scoped=true"
import script from "./studentActivity.vue?vue&type=script&lang=js"
export * from "./studentActivity.vue?vue&type=script&lang=js"
import style0 from "./studentActivity.vue?vue&type=style&index=0&id=1a629c14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a629c14",
  null
  
)

export default component.exports